import Head from "expo-router/head";

import SignIn from "@/auth/SignIn";
import { brandName } from "@/config/brand";

export default function SignInPage() {
  return (
    <>
      <Head>
        <title>{`Sign In — ${brandName}`}</title>
      </Head>
      <SignIn />
    </>
  );
}
